module.exports = __webpack_public_path__ + "img/volume_up_grey.6f73f8b4.svg";